export const FONT_FACE = 'Arial';

export const LABEL_COLOR = '#000000';
export const LINE_COLOR = 'cccccc';
export const LINK_COLOR = '#5c8488';
export const TEXT_COLOR = '#064a51';
export const CHART_LABEL_NEGATIVE_COLOR = '#ea526f';
export const CHART_LABEL_POSITIVE_COLOR = '#00a755';

export const TABLE_BORDER = { color: TEXT_COLOR, pt: 0.5 };

export const TABLE_FONT_SIZE = 8;

export const TITLE_TEXT = {
  bold: true,
  breakLine: true,
  color: TEXT_COLOR,
  fontFace: FONT_FACE,
  fontSize: 20,
  h: 'auto',
  valign: 'top',
  w: '95%',
  wrap: true,
  x: 0.5,
  y: 0.5,
};

export const SURVEY_TITLE_OPTIONS = {
  ...TITLE_TEXT,
  breakLine: true,
  fontSize: 14,
  h: 'auto',
  shrinkText: true,
  valign: 'top',
  y: 0.2,
};

export const FOOTER_TEXT = {
  color: LINK_COLOR,
  fontFace: FONT_FACE,
  fontSize: 10,
  italic: true,
  x: 0.5,
  y: 5.15,
};

export const KEY_FINDINGS_TEXT = {
  breakLine: true,
  color: TEXT_COLOR,
  fontFace: FONT_FACE,
  fontSize: 12,
  h: 3.0,
  valign: 'right',
  w: 4.5,
  wrap: true,
  x: 8.5,
  y: 1.4,
};

export const READ_AS_TEXT = {
  breakLine: true,
  color: TEXT_COLOR,
  fontFace: FONT_FACE,
  fontSize: 8,
  h: 'auto',
  valign: 'top',
  w: '85%',
  wrap: true,
  x: 0.5,
  y: 1.2,
};
